import { Component, OnInit } from '@angular/core';
import { Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { UploadFile, UploaderOptions, UploadInput, UploadOutput, humanizeBytes } from 'ngx-uploader';
import { LanguageConstants } from '../../shared-components/constant';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
@Component({
  standalone: false,
  selector: 'app-popupconfirm',
  templateUrl: './popupconfirm.component.html',
  styleUrls: ['./popupconfirm.component.css']
})
export class PopupconfirmComponent implements OnInit {
  options: UploaderOptions;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  loadspinner = false;
  isFileFormatCorrect = false;
  uploadInput: EventEmitter<UploadInput>;
  sourceFiles: UploadFile[];
  humanizeBytes: Function;
  databook: any;
  dragOver: boolean;
  downloadErrorLogConfigUrl: string;
  engagementId = +this.route.snapshot.paramMap.get('id');
  configUrl: string;
  uploaddatabook = false;
  downloadenable = true;
  timeOutHandler: NodeJS.Timer;
  isTimeIntervalInProgress = false;
  webJobQueueId: number;
  previousStep: string;
  langCode: string;
  currLangTranslation: any;
  constructor(private route: ActivatedRoute, private translateService: TranslateService) {

    this.options = {
      concurrency: 1, allowedContentTypes: [
        'application/vnd.ms-excel.sheet.macroEnabled.12']
    };
    this.sourceFiles = [];
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  @Input() display = false;
  @Output() selecteddisplayevent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() okEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updateDataTabEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];

    this.previousStep = this.currLangTranslation.actionButtons.previousStep;
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
      this.previousStep = this.currLangTranslation.actionButtons.previousStep;
    });
  }
  ClosePopup() {
    if (this.display) {
      this.display = false;
      this.closeEvent.emit(this.display);
    }
  }
  OkPopupclick() {
    this.display = false;
    this.okEvent.emit(this.display);
  }
  OkGenerateclick() {
    this.display = false;
    this.updateDataTabEvent.emit(this.display);
  }

  confirmdisplay = false;
  closeEventworkallocation($event) {

    this.confirmdisplay = $event;
  }

}
